export const steps = [
    // 'Select type',
    // 'Select Form templates',
    'Fill out the form',
    // 'Review and Sign the Forms',
    'Review the Forms',
    // 'Sign'
];
